import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { ChildScores, InferValuesTypes } from '@yandex-int/k-common/typings';

import * as actions from './actions';

export type Certificates = Record<number, string>;

export interface CertificatesItem {
    certificates: Certificates;
    loadingStatus: LOADING_STATUSES;
}

export interface CertificatesStore {
    certificateList: Record<number, CertificatesItem>;
    scores: Record<number, ChildScores>;
}

export interface ReduxCertificatesStore {
    certificates: CertificatesStore;
}

export type CertificatesAction = ReturnType<InferValuesTypes<typeof actions>>;

export enum GET_CHILDREN_SCORE_ERROR_MESSAGE {
    NOT_SCORED = 'Not scored clesson!',
    NOT_PUBLISHED = 'Results are not published.',
}
